import { env } from '@/env';

import { AuthAdapter } from './auth-adapter';
import { FirebaseAdapter } from './firebase-adapter';
import { OIDCAdapter } from './oidc-adapter';

export function createAuthAdapter(): AuthAdapter {
  const provider = env.NEXT_PUBLIC_AUTH_PROVIDER;

  switch (provider) {
    case 'oidc': {
      if (
        !env.NEXT_PUBLIC_OIDC_AUTHORITY ||
        !env.NEXT_PUBLIC_OIDC_CLIENT_ID ||
        !env.NEXT_PUBLIC_OIDC_REDIRECT_URI
      ) {
        throw new Error(
          'OIDC auth provider requires NEXT_PUBLIC_OIDC_AUTHORITY, NEXT_PUBLIC_OIDC_CLIENT_ID, and NEXT_PUBLIC_OIDC_REDIRECT_URI',
        );
      }

      return new OIDCAdapter({
        authority: env.NEXT_PUBLIC_OIDC_AUTHORITY,
        clientId: env.NEXT_PUBLIC_OIDC_CLIENT_ID,
        redirectUri: env.NEXT_PUBLIC_OIDC_REDIRECT_URI,
        postLogoutRedirectUri: env.NEXT_PUBLIC_OIDC_POST_LOGOUT_REDIRECT_URI,
        scopes: env.NEXT_PUBLIC_OIDC_SCOPES?.split(' '),
      });
    }

    case 'firebase': {
      if (!env.NEXT_PUBLIC_FIREBASE_CONFIG) {
        throw new Error(
          'Firebase auth provider requires NEXT_PUBLIC_FIREBASE_CONFIG environment variable',
        );
      }
      return new FirebaseAdapter();
    }

    case 'rest':
      throw new Error('REST auth provider is not yet implemented');

    case undefined:
      throw new Error(
        'No auth provider configured. Set NEXT_PUBLIC_AUTH_PROVIDER to "oidc", "firebase", or "rest"',
      );

    default:
      throw new Error(`Unknown auth provider: ${provider}`);
  }
}
